/* eslint-disable react/prop-types */
import React from 'react';
import { LINKS } from '../../../../../constants';

const ComeetApply = ({ positionUid }) => (
    <div className="comeet-apply">
        <script
            data-css-cache="false"
            data-labels-position="top"
            type="comeet-applyform"
            data-field-website="false"
            data-field-portfolio="false"
            data-field-questionnaires="false"
            data-field-coverletter="false"
            data-field-personalnote="false"
            data-thankyou-url={`https://www.fiverr.com/jobs/${LINKS.APPLIED}`}
            data-apply-as-employee="false"
            data-position-uid={positionUid}
        />
    </div>
);

export default ComeetApply;
